import * as React from "react";

const IconOverflowMenu: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path
                fill="currentColor"
                d="M76.999999,15.9999995 C76.999999,10.9982815 74.3316154,6.37650299 69.999999,3.87564468 C65.6683846,1.37478447 60.3316154,1.37478447 55.999999,3.87564468 C51.6683846,6.37650299 48.999999,10.9982815 48.999999,15.9999995 C48.999999,21.0017185 51.6683846,25.623497 55.999999,28.1243553 C60.3316154,30.6252155 65.6683846,30.6252155 69.999999,28.1243553 C74.3316154,25.623497 76.999999,21.0017185 76.999999,15.9999995 Z M47,16 C47,10.2837505 50.0495825,5.00171852 55,2.14359283 C59.9504175,-0.714530945 66.0495834,-0.714530945 71,2.14359283 C75.9504166,5.00171852 79,10.2837505 79,16 C79,21.7162495 75.9504166,26.9982815 71,29.8564072 C66.0495834,32.7145309 59.9504175,32.7145309 55,29.8564072 C50.0495825,26.9982815 47,21.7162495 47,16 Z M61.5,20.5 L64.5,20.5 L64.5,23.5 L61.5,23.5 L61.5,20.5 Z M61.5,8.5 L64.5,8.5 L64.5,11.5 L61.5,11.5 L61.5,8.5 Z M61.5,17.5 L61.5,14.5 L64.5,14.5 L64.5,17.5 L61.5,17.5 Z"
                transform="translate(-47)"
            />
        </svg>
    );
};

export default React.memo(IconOverflowMenu);
